import styled from 'styled-components';
import warningCriticalIconUrl from 'lib/assets/images/icons/Warning_Critical_icon.svg';
import { maxWidth } from 'config/constants';

export const StyledDeviceIdentificationForm = styled.div`
  .device-form__content {
    display: flex;
    flex-direction: column;
    gap: ${(props): string => props.theme.kcc.spacing.BASE};
    flex: 1;
  }

  .device-form__field {
    max-width: 755px;
  }

  .device-form__field--material-number {
    ${maxWidth.l} {
      margin-bottom: 8px;
    }
  }

  .device-form__label {
    display: flex;
    align-items: center;
    gap: ${(props): string => props.theme.kcc.spacing.XXS};
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    margin-bottom: ${(props): string => props.theme.kcc.spacing.XS};
  }

  .device-form__info-icon {
    display: inline-flex;
    align-items: center;
    cursor: pointer;

    .svg-icon {
      width: 20px;
      height: 20px;
    }
  }

  .device-form__help-link {
    text-align: left;
    align-self: flex-start;
    display: inline-block;
    text-decoration: underline;
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
  }

  .device-form__check-icon {
    display: flex;

    svg {
      width: 20px;
      height: 20px;

      path {
        stroke: ${(props): string => props.theme.kcc.colors.SUCCESS};
        stroke-width: 1.5;
      }
    }
  }

  .device-form__input--valid {
    border-color: ${(props): string => props.theme.kcc.colors.SUCCESS};
  }

  .ant-input {
    line-height: normal;
  }

  .ant-form-item {
    margin-bottom: 0;
  }

  .ant-form-item-explain-error {
    padding-left: ${(props): string => props.theme.kcc.spacing.XS};
    margin-top: 10px;
    display: flex;
    align-items: center;
    gap: 6px;

    &::before {
      content: '';
      display: block;
      flex-shrink: 0;
      width: 12px;
      height: 12px;
      background-color: ${(props): string => props.theme.kcc.colors.ERROR};
      mask-image: url(${warningCriticalIconUrl});
      mask-size: 12px 12px;
      mask-repeat: no-repeat;
    }
  }
`;
